import { Form } from 'radix-ui';
import { forwardRef, type ComponentPropsWithoutRef, type ReactElement } from 'react';
import { Flex } from '@radix-ui/themes';
import { applySizeClass, cn, iconSizeClasses } from '@/lib/utils';
import { type RadixTextSize } from './RadixProps';
import { Text } from './Text';

type LabelSize = keyof typeof iconSizeClasses;

interface LabelProps extends ComponentPropsWithoutRef<typeof Form.Label> {
  htmlFor?: string;
  size?: RadixTextSize;
  icon?: ReactElement;
  iconSize?: LabelSize;
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, htmlFor, size, icon, iconSize = 'sm', children, ...props }, ref) => (
    <Form.Label
      ref={ref}
      htmlFor={htmlFor}
      className={cn('data-invalid:text-destructive', className)}
      {...props}
    >
      <Flex align="center" gap="2">
        {icon && applySizeClass(icon, iconSize)}
        <Text size={size ?? '1'}>{children}</Text>
      </Flex>
    </Form.Label>
  )
);

Label.displayName = 'Label';

export { Label };
export type { LabelProps };
